import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import reducers from './ducks';
import history from './history';
import { routerMiddleware } from 'react-router-redux';
import { persistReducer, persistStore } from 'redux-persist';
import loggerMiddleware from 'components/commons/blockUi/middleware/BlockUiMiddleware';

const routing = routerMiddleware(history);

// TODO: investigate why validation is set to false, because this is useless
export const storeUsesPersist = false && process.env.CI !== 'true' && process.env.NODE_ENV === 'development';

let persistedReducers;
if (storeUsesPersist) {
  const storage = require('redux-persist/lib/storage').default;
  const persistConfig = {
    key: 'root',
    blacklist: ['userDetails', 'login'],
    storage,
  };
  persistedReducers = persistReducer(persistConfig, reducers);
}

const store = configureStore({
  reducer: persistedReducers || reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: true,
    }).concat(routing, thunk, loggerMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistedReducers && persistStore(store);
export default store;